<template>
  <Modal v-model="visible" title="新增回款" width="800" :mask-closable="false" :footer-hide="true" class="my-modal top">
    <Form :model="formData" ref="infoFormRef" class="page-form less" :label-width="75" v-if="visible">
      <FormItem label="凭证编号" prop="collectionCode" class="form-item">
        <Input v-model="formData.collectionCode" placeholder="请输入" />
      </FormItem>

      <FormItem label="收款日期" prop="collectionDate" class="form-item" :rules="$units.formRule.required('请选择日期', (trigger = 'change'), (type = 'date'))">
        <DatePicker type="date" v-model.trim="formData.collectionDate" format="yyyy-MM-dd" transfer placeholder="选择日期"></DatePicker>
      </FormItem>

      <FormItem label="回款金额" prop="collectionAmount" class="form-item" :rules="$units.formRule.required('请输入付款金额', 'change', 'number')">
        <InputNumber v-model="formData.collectionAmount" :min="0" placeholder="请输入"></InputNumber>
      </FormItem>

      <FormItem label="收款账户" prop="collectionAccount" class="form-item">
        <Input v-model="formData.collectionAccount" placeholder="请输入" />
      </FormItem>

      <FormItem label="凭证照片" prop="billImages">
        <uploadNew v-model="billImages" @change="imgUploadMobile" @remove="$set(formData, 'billImages', '')"></uploadNew>
      </FormItem>
    </Form>

    <div class="ivu-modal-footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import filter from '@/api/filter';
export default {
  components: { uploadNew },
  data() {
    return {
      reportId: null,
      visible: false,
      billImages: [],
      formData: {
        collectionAmount: null
      }
    };
  },

  methods: {
    open(reportId) {
      this.visible = true;
      this.reportId = reportId;
      this.formData = {
        collectionAmount: null
      };
    },

    imgUploadMobile() {
      if (this.formData.billImages && this.formData.billImages[0]) {
        this.$set(this.formData, 'billImages', this.formData.billImages[0].path);
      }
    },

    ok() {
      this.$refs.infoFormRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        let data = {
          reportId: this.reportId,
          collectionCode: this.formData.collectionCode,
          collectionDate: filter.filterTime(this.formData.collectionDate, 'YYYY-MM-DD'),
          collectionAmount: this.formData.collectionAmount,
          collectionAccount: this.formData.collectionAccount,
          billImages: this.billImages.length ? this.billImages[0].path : ''
        };
        this.$http({
          url: '/buz/settlementReport/addCheckReturnedMoney',
          type: 'POST',
          data
        }).then(res => {
          this.visible = false;
          this.$notice.success('新增成功');
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
